import React,{createContext,useEffect,useState} from 'react';
import axios from "axios";
import {config} from "../../config";
import Overlay from "../../components/Overlay";


const PageContext = createContext({});

export const PageProvider = ({children}) => {

	const [pageData,setPageData] = useState(null);

	const [pageLoading,setPageLoading] = useState(true);

	const [scrollY,setScrollY] = useState(0);

	const [screenH,setScreenH] = useState(document.documentElement.clientHeight);

	const isHome = window.pageId === 6;

	useEffect(() => {
		const handleScroll = () => {
			setScrollY(window.scrollY);
		};
		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	},[]);

	useEffect(() => {
		const handleScroll = () => {
			setScreenH(document.documentElement.clientHeight);
		};
		window.addEventListener('resize', handleScroll);

		return () => {
			window.removeEventListener('resize', handleScroll);
		};
	},[])

	useEffect( ()=>{
		const currentPageId = window.pageId;

		axios
			.get(
				config.domainRelPath+'/wp-json/acf/v3/pages/?per_page=100'
			)
			.then(res => {
				const currentPageData = res.data.find(page=>page.id===currentPageId).acf;
				setPageData(currentPageData);
				setPageLoading(false);
			})
			.catch(error => console.log(error));

	},[
		setPageLoading,
		setPageData,
	]);

	return (
		<PageContext.Provider value={{
			isHome,
			pageData,
			scrollY,
			screenH
		}}>
			{pageLoading && <Overlay />}
			{pageData && children}
		</PageContext.Provider>
	);
};

export default PageContext;